import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CellClickedEvent, ColDef, CsvCell, CsvExportParams, ExcelCell, ExcelExportParams, ExcelRow, ExcelStyle, IsRowMaster, ProcessRowGroupForExportParams, RowSpanParams, } from 'ag-grid-community';

import { timeEnd } from 'console';
import { el } from 'date-fns/locale';
import { difference } from 'lodash-es';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { BtnCellRendererWaste } from 'src/app/btnCellRendererWaste';
import { BtnCellRendererWasteHistory } from 'src/app/btnCellRendererWasteHistory';
import { CustomLoadingOverlay } from 'src/app/custom-loading-overlay.component';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { Multilingual } from 'src/app/services/multilingual';
import { OrderProcessingService } from 'src/app/services/orderprocessing.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { WasteService } from 'src/app/services/waste.service';
import * as XLSX from 'xlsx-js-style';
@Component({
  selector: 'app-waste-detail',
  templateUrl: './waste-detail.component.html',
  styleUrls: ['./waste-detail.component.scss']
})
export class WasteDetailComponent implements OnInit {

  wasteFilterForm: FormGroup;
  AddWasteEnteryForm: FormGroup;
  filteredGroups!: any[];
  groupList!: any[];
  plantList!: any[];
  filteredPlant!: any[];
  poList!: any[];
  filteredPo!: any[];
  unitList!: any[];
  filteredUnit!: any[];
  faultList!: any[];
  gridApi: any;
  gridApi1: any;
  gridApiWast: any;
  gridColumnApi: any;
  gridColumnApi1: any;
  gridColumnApiWast: any;
  rowData!: any[];
  columnDefs!: any[];
  columnDefsHistory: any[];
  columnDefWastHistory: any[];
  rowDataHistory: any[];
  wastDataHistory: any[] = [];
  permisson!: any;
  IsAccess!: any;
  IsWrite!: any;
  breadcrumList!: any;
  gridRowObj: any;
  historyGridRowObj: any;
  wasteLabel: any;
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  editMode = false;
  languageDir = 'ltr';
  loadingOverlayComponent: any;
  paramsData: any;
  public detailCellRendererParams!: any;
  childRowSpan: number = 1;
  wastDialogRef: any;
  public excelStyles: ExcelStyle[] = [
    {
      id: 'header',
      interior: {
        color: '#aaaaaa',
        pattern: 'Solid',
        patternColor: ''
      },
    },
    {
      id: 'body',
      interior: {
        color: '#dddddd',
        pattern: 'Solid',
        patternColor: ''
      },
    },
  ];
  public defaultExcelExportParams: ExcelExportParams = {
    getCustomContentBelowRow: (params) => this.getRows(params) as any[],
    columnWidth: 120,
    fileName: 'Wast Entry.xlsx',
  };

  public columnDefsnew: ColDef[] = [
    // group cell renderer needed for expand / collapse icons
    { field: 'name', cellRenderer: 'agGroupCellRenderer' },
    { field: 'account' },
    { field: 'calls' },
    { field: 'minutes', valueFormatter: "x.toLocaleString() + 'm'" },
  ];
  public defaultColDefnew: ColDef = {
    flex: 1,
  };

  public detailCellRendererParamsnew: any = {
    detailGridOptions: {
      columnDefs: [
        { field: 'callId' },
        { field: 'direction' },
        { field: 'number', minWidth: 150 },
        { field: 'duration', valueFormatter: "x.toLocaleString() + 's'" },
        { field: 'switchCode', minWidth: 150 },
      ],
      defaultColDefnew: {
        flex: 1,
      },
    },

    getDetailRowData: (params) => {
      params.successCallback(params.data.callRecords);
    },
  };
  public isRowMaster: IsRowMaster = (dataItem: any) => {
    return dataItem ? dataItem?.detail?.length > 0 : false;
  };

  gridOptions: any = {
    CodefaultlDef: {
      //rowModelType: 'infinite',
      //infiniteInitialRowCount: 2,
      enableColResize: true,
      //flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      // autoHeight: true, // <-- & HERE
      // minWidth: 225,
    },
    frameworkComponents: {
      btnCellRendererWaste: BtnCellRendererWaste,
      customLoadingOverlay: CustomLoadingOverlay,
    },
    // medalColumn: {
    //   width: 100,
    //   columnGroupShow: 'open',
    //   filter: false,
    // },
    //popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  gridOptionsHistory: any = {
    CodefaultlDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      // autoHeight: true, // <-- & HERE
      // minWidth: 225,
    },
    frameworkComponents: {
      btnCellRendererWasteHistory: BtnCellRendererWasteHistory,
      customLoadingOverlay: CustomLoadingOverlay,
    },
    // medalColumn: {
    //   width: 100,
    //   columnGroupShow: 'open',
    //   filter: false,
    // },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  gridOptionsWastHistory: any = {
    CodefaultlDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      // autoHeight: true, // <-- & HERE
      // minWidth: 225,
    },
    frameworkComponents: {
      btnCellRendererWasteHistory: BtnCellRendererWasteHistory,
      customLoadingOverlay: CustomLoadingOverlay,
    },
    // medalColumn: {
    //   width: 100,
    //   columnGroupShow: 'open',
    //   filter: false,
    // },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  @ViewChild('addWasteModal') private addWasteModal!: TemplateRef<any>;
  @ViewChild('wastHistory') private wastHistoryModal!: TemplateRef<any>;
  formattedDetailArray: any[] = [];
  filteredArray: any[] = [];
  gridApinew: any;
  rowDatanew: any[] = [];
  exportType: string;
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserManagementService,
    private machineService: MachineMappingService,
    private toaster: ToastrService,
    private enterpriseGroupService: EnterPriseGroupService,
    private wasteService: WasteService,
    private dialog: MatDialog,
    public translater: TranslaterService,
    public translate: TranslateService,
    public router: Router,
  ) {
    this.loadingOverlayComponent = 'customLoadingOverlay';
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.GetBreadcrumList();
  };

  ngOnInit() {
    this.wasteFilterForm = this.formBuilder.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
      processOrder: ['', Validators.required],
      unit: ['', Validators.required],
      dateStart: new FormControl(),
      dateEnd: new FormControl(),
    });
    this.AddWasteEnteryForm = this.formBuilder.group({
      po: [''],
      machine: [''],
      operation: [''],
      item: [''],
      categoryType: ['', Validators.required],
      amount: ['', Validators.required],
      remarks: [''],
      datePicker: ['']
      // dateStart:      new FormControl(),
      // dateEnd:        new FormControl(),
    });
    this.GetMenuAccess();
    //this.GetBreadcrumList();
    this.setDateByDefaut();
    this.datasource()
  };

  getRows(params: ProcessRowGroupForExportParams) {
    const array = [];
    const rows = [
      [
        this.cell(''),
        this.cell('Item', 'header'),
        this.cell('Serial No', 'header'),
        this.cell('Operation Name', 'header'),
        this.cell('Machine', 'header'),
        this.cell('Start Date', 'header'),
        this.cell('End Time', 'header'),
        this.cell('Gross Produced', 'header'),
        this.cell('Net Produced', 'header'),
        this.cell('Waste', 'header'),
        this.cell('Waste Reason', 'header'),
        this.cell('Category Type', 'header'),
      ],
    ].concat(
      ...params.node.data.detail.map((record: any) => [
        [
          this.cell(''),
          this.cell(record.SerialNo, 'body'),
          this.cell(record.ItemDesc, 'body'),
          this.cell(record.PPD_Desc, 'body'),
          this.cell(record.PU_Desc, 'body'),
          this.cell(record.Start_Time ? moment(record.Start_Time).format('DD/MM/YYYY HH:mm A') : '', 'body'),
          this.cell(record.End_Time ? moment(record.End_Time).format('DD/MM/YYYY HH:mm A') : '', 'body'),
          this.cell(record.GrossProduced, 'body'),
          this.cell(record.NetProduced, 'body'),
          this.cell(record.Waste, 'body'),
          this.cell(record.WasteReson, 'body'),
          this.cell(record.faultName, 'body'),
        ],
      ])
    );
    if (this.exportType === 'Parent') {
      return array;
    } else {
      return rows;
    }
  };

  cell(text: string, styleId?: string): ExcelCell {
    return {
      styleId: styleId,
      data: {
        type: /^\d+$/.test(text) ? 'Number' : 'String',
        value: String(text),
      },
    };
  }

  exportExcelData(type: string) {
    this.exportType = type;
    this.gridApi1.exportDataAsExcel();
  }

  onBtnExportWaste(): void {
    const dataSheet = [];
    if (this.rowData.length === 0) {
      this.toaster.warning('Warning', 'Data not found');
      return;
    }
    const workBook = XLSX.utils.book_new();
    const merge = [];
    let row: number = 0;
    let n: number = 1;
    for (let i of this.rowData) {
      if (i.detail.length > 0) {
        const length = i.detail.length;
        row += length;
        if (n === 1) {
          merge.push(
            { s: { r: 1, c: 0 }, e: { r: row, c: 0 } },
            { s: { r: 1, c: 1 }, e: { r: row, c: 1 } },
            { s: { r: 1, c: 2 }, e: { r: row, c: 2 } },
            { s: { r: 1, c: 3 }, e: { r: row, c: 3 } },
            { s: { r: 1, c: 4 }, e: { r: row, c: 4 } },
            { s: { r: 1, c: 5 }, e: { r: row, c: 5 } },
          );
        } else {
          merge.push(
            { s: { r: (row - length) + 1, c: 0 }, e: { r: row, c: 0 } },
            { s: { r: (row - length) + 1, c: 1 }, e: { r: row, c: 1 } },
            { s: { r: (row - length) + 1, c: 2 }, e: { r: row, c: 2 } },
            { s: { r: (row - length) + 1, c: 3 }, e: { r: row, c: 3 } },
            { s: { r: (row - length) + 1, c: 4 }, e: { r: row, c: 4 } },
            { s: { r: (row - length) + 1, c: 5 }, e: { r: row, c: 5 } },
          );
        }
        for (let d of i.detail) {
          dataSheet.push({
            ['Process Order ']: i.ProcessOrder,
            ['Start Time ']: i.Start_Time ? moment(i.Start_Time).format('DD/MM/YYYY hh:mm') : '',
            ['End Time ']: i.End_Time ? moment(i.End_Time).format('DD/MM/YYYY hh:mm') : '',
            ['Gross Produced']: (i.GrossProduced && i.GrossProduced > 0) ? i.GrossProduced : 0,
            ['Net Produced']: (i.NetProduced && i.NetProduced > 0) ? i.NetProduced : 0,
            ['Waste']: i.Waste ? i.Waste : 0,
            ['Seriol No']: d.SerialNo,
            ['Item ']: d.ItemDesc,
            ['Operation Name ']: d.PPD_Desc,
            ['Machine ']: d.PU_Desc,
            ['Start Date ']: d.Start_Time ? moment(d.Start_Time).format('DD/MM/YYYY HH:mm A') : '',
            ['End Date ']: d.End_Time ? moment(d.End_Time).format('DD/MM/YYYY HH:mm A') : '',
            ['Gross Produced ']: (d.GrossProduced && d.GrossProduced > 0) ? d.GrossProduced : 0,
            ['Net Produced ']: (d.NetProduced && d.NetProduced > 0) ? d.NetProduced : 0,
            ['Waste ']: d.Waste ? d.Waste : 0,
            ['Waste Reason ']: d.WasteReson ? d.WasteReson : '',
            ['Category Type']: d.faultName ? d.faultName : ''
          });
          n++;
        }
      } else {
        dataSheet.push({
          ['Process Order ']: i.ProcessOrder,
          ['Start Time ']: i.Start_Time ? moment(i.Start_Time).format('DD/MM/YYYY HH:mm A') : '',
          ['End Time ']: i.End_Time ? moment(i.End_Time).format('DD/MM/YYYY HH:mm A') : '',
          ['Gross Produced']: (i.GrossProduced && i.GrossProduced > 0) ? i.GrossProduced : 0,
          ['Net Produced']: (i.NetProduced && i.NetProduced > 0) ? i.NetProduced : 0,
          ['Waste']: i.Waste ? i.Waste : 0
        });
        n++;
      }
    }
    const sheet = XLSX.utils.json_to_sheet(dataSheet);
    for (var i in sheet) {
      if (typeof sheet[i] != 'object') continue;
      let cell = XLSX.utils.decode_cell(i);
      sheet[i].s = {
        // styling for all cells
        font: {
          name: 'arial',
          sz: '12'
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
          //wrapText: '1', 
        },
        border: {
          right: {
            style: 'thin',
            color: 'B2B2B2',
          },
          left: {
            style: 'thin',
            color: 'B2B2B2',
          },
          bottom: {
            style: 'thin',
            color: 'B2B2B2',
          },
          top: {
            style: 'thin',
            color: 'B2B2B2',
          },
        },
      };

      if (cell.c >= 6) {
        sheet[i].s.fill = {
          // background color
          patternType: 'solid',
          fgColor: { rgb: 'F2F2F2' },
          bgColor: { rgb: 'F2F2F2' },
        };
      }

      if (cell.r == 0) {
        // first row #DDDDDD
        sheet[i].s.fill = {
          // background color  000000
          patternType: 'solid',
          fgColor: { rgb: 'b2b2b2' },
          bgColor: { rgb: 'b2b2b2' },
        };
      }
    }
    const cWidth = [{ wch: 35 }, { wch: 18.57 }, { wch: 18.57 }, { wch: 17.14 }, { wch: 14.43 }, { wch: 9 }, { wch: 10 }, { wch: 45 }, { wch: 45 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 18.57 }, { wch: 15 }, { wch: 10 }, { wch: 40 }, { wch: 40 }];
    sheet['!merges'] = merge;
    sheet['!cols'] = cWidth;
    XLSX.utils.book_append_sheet(workBook, sheet, 'Waste Entry');
    XLSX.writeFile(workBook, `Waste Entry.xlsx`);
  }


  setDateByDefaut(): void {
    let date = new Date();
    this.wasteFilterForm.get('dateStart').setValue(new Date(date.getFullYear(), date.getMonth(), 1));
    this.wasteFilterForm.get('dateEnd').setValue(new Date());
  };
  openWastHistoryModal(params: any) {
    this.paramsData = params.data;
    const dataArray = params.data?.detail.slice();
    dataArray.forEach((item: any) => item.startTime = moment(item.Start_Time).format('DD/MM/YYYY HH:mm'));
    const arrayUnique: any[] = dataArray.filter((person, index, selfArray) =>
      index === selfArray.findIndex((p) => (
        p.PPD_Desc === person.PPD_Desc && p.startTime === person.startTime
      ))
    );
    const uniqueNames: any[] = arrayUnique.map((x: any) => {
      return { 'PPD_Desc': x.PPD_Desc, 'startTime': x.startTime };
    })
    const formattedArray: any[] = [];
    uniqueNames.forEach(area => {
      const filteredArray = dataArray.filter((x: any) => x?.PPD_Desc === area.PPD_Desc && x?.startTime === area.startTime);
      if (filteredArray.length > 0) {
        filteredArray.forEach((meeting: any) => {
          const found = formattedArray.findIndex((item: any) => {
            return item?.PPD_Desc?.name === area && item?.startTime === area.startTime;
          });
          if (found === -1) {
            formattedArray.push({
              PPD_Desc: {
                name: area
              },
              ItemDesc: meeting?.ItemDesc,
              PU_Desc: meeting?.PU_Desc,
              Start_Time: meeting?.Start_Time,
              End_Time: meeting?.End_Time,
              Waste: meeting?.Waste,
              WasteReson: meeting?.WasteReson,
              totalcount: filteredArray?.length,
              faultName: meeting?.faultName,
              GrossProduced: meeting?.GrossProduced,
              startTime: meeting?.startTime,
              PU_Id: meeting?.PU_Id,
              Label: meeting?.Label,
              ProcessOrder: meeting?.ProcessOrder,
              PPD_ID: meeting?.PPD_ID
            });
          } else {
            formattedArray.push({
              Waste: meeting?.Waste,
              FaultName: meeting?.faultName,
              WasteReson: meeting?.WasteReson,
              // GrossProduced: meeting?.GrossProduced,
              NetProduced: meeting?.NetProduced,
            });
          }
        });
      }
    });
    this.wastDataHistory = formattedArray;
    this.wastDialogRef = this.dialog.open(this.wastHistoryModal, { height: 'auto', width: '90%', maxHeight: '80vh' });
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;

        // this.IsWrite = false; 
        this.columnDefs = [
          {
            headerName: 'PO#',
            field: 'ProcessOrder',
            filter: 'agTextColumnFilter',
            cellRenderer: 'agGroupCellRenderer',
            sortable: true,
            resizable: true,
            wrapText: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Start Date',
            field: 'Start_Time',
            // filter:     'agDateColumnFilter',
            valueFormatter: function (params: any) {
              if (params.value) {
                return moment(params.value).format('DD/MM/YYYY HH:mm:ss');

              }
              else {
                return ''
              }
            },
            sortable: true,
            resizable: true,
            wrapText: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'End Time',
            field: 'End_Time',
            // filter:     'agDateColumnFilter',
            valueFormatter: function (params: any) {
              if (params.value) {

                return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
              }
              else {
                return ''
              }
            },
            sortable: true,
            resizable: true,
            wrapText: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Gross Produced',
            field: 'GrossProduced',
            filter: 'agTextColumnFilter',
            // hide: true,
            sortable: true,
            resizable: true,
            wrapText: true,
          },
          {
            headerName: 'Net Produced ',
            field: 'NetProduced',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            width: 250,
            valueFormatter: function (params: any) {
              if (params.value < 0) {

                return 0;
              }
              else {
                return params.value
              }
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Waste',
            field: 'Waste',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            width: 260
            // headerValueGetter: this.localizeHeader.bind(this)
          },

        ];
        this.columnDefsHistory = [
          {
            field: 'Action',
            // headerName: this.langObj ? this.langObj?.Actions : 'Actions',
            cellRenderer: 'btnCellRendererWasteHistory',
            cellRendererParams: {
              clicked: function (field: any) { },
            },
            sortable: true,
            resizable: true,
            width: 100,
            wrapText: true,
          },
          {
            headerName: 'Catagory Type',
            field: 'WEFault_Name',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            eaderValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Waste Entry',
            field: 'Amount',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            eaderValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Remarks',
            field: 'Remarks',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            eaderValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Created On',
            field: 'CreatedOn',
            // filter:     'agDateColumnFilter',
            valueFormatter: function (params: any) {
              if (params.value) {
                return moment(params.value).format('DD/MM/YYYY HH:mm');

              }
              else {
                return ''
              }
            },
            sortable: true,
            resizable: true,
            wrapText: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Entry On',
            field: 'Entry_On',
            // filter:     'agDateColumnFilter',
            valueFormatter: function (params: any) {
              if (params.value) {
                return moment(params.value).format('DD/MM/YYYY HH:mm');
              }
              else {
                return ''
              }
            },
            sortable: true,
            resizable: true,
            wrapText: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
        ]
        this.columnDefWastHistory = [
          {
            field: 'Action',
            cellRenderer: 'btnCellRendererWasteHistory',
            cellRendererParams: {
              clicked: function (field: any) { },
            },
            resizable: true,
            width: 100,
            wrapText: true,
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
          },
          {
            headerName: 'Item',
            field: 'ItemDesc',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            cellRenderer: (params: any) => {
              if (params.value && params.value) {
                return '<div>' +
                  params.value +
                  '' +
                  '</div>';
              } else { return ''; }
            },
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Operation Name',
            field: 'PPD_Desc',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            cellRenderer: (params: any) => {
              
              if (params.value && params.value.name) {
                return '<div>' +
                  params.value.name.PPD_Desc +
                  '' +
                  '</div>';
              } else { return ''; }
            },
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value.name) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Machine',
            field: 'PU_Desc',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            cellRenderer: (params: any) => {
              if (params.value && params.value) {
                return '<div>' +
                  params.value +
                  '' +
                  '</div>';
              } else { return ''; }
            },
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Start Date',
            field: 'Start_Time',
            sortable: true,
            resizable: true,
            wrapText: true,
            cellRenderer: (params: any) => {
              if (params.value && params.value) {
                return '<div>' +
                  moment(params.value).format('DD/MM/YYYY HH:mm') +
                  '' +
                  '</div>';
              } else { return ''; }
            },
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'End Time',
            field: 'End_Time',
            cellRenderer: (params: any) => {
              if (params.value && params.value) {
                return '<div>' +
                  moment(params.value).format('DD/MM/YYYY HH:mm') +
                  '' +
                  '</div>';
              } else { return ''; }
            },
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
            sortable: true,
            resizable: true,
            wrapText: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Gross Produced',
            field: 'GrossProduced',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            cellRenderer: (params: any) => {
              if (params.value && params.value) {
                return '<div>' +
                  params.value +
                  '' +
                  '</div>';
              } else { return ''; }
            },
            rowSpan: this.rowSpan,
            cellClassRules: { 'show-cell': 'value !== undefined' },
            cellStyle: (params: any) => {
              if (params.value && params.value) {
                return { background: '#ffffff', border: '1px solid #f9f9f9' };
              } else {
                return { background: '#ffffff' };
              }
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Net Produced',
            field: 'NetProduced',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            // cellRenderer: (params: any) => {
            //   if (params.value && params.value > 0) {
            //     return '<div>' +
            //       params.value +
            //       '' +
            //       '</div>';
            //   } else { return '<div>0</div>'; }
            // },
            //rowSpan: this.rowSpan,
            // cellClassRules: { 'show-cell': 'value !== undefined' },
            // cellStyle: (params: any) => {
            //   if (params.value && params.value) {
            //     return { background: '#ffffff', border: '1px solid #f9f9f9'};
            //   } else {
            //     return { background: '#ffffff' };
            //   }
            // },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Waste',
            field: 'Waste',
            sortable: true,
            resizable: true,
            wrapText: true,

          },
          {
            headerName: 'Waste Reason',
            field: 'WasteReson',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            // headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Waste Category',
            field: 'FaultName',
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            wrapText: true,
            // headerValueGetter: this.localizeHeader.bind(this)
          },
        ]
        this.detailCellRendererParams = {
          detailGridOptions: {
            onCellClicked: (event: CellClickedEvent) => this.detailCellClicked(event),
            //groupDefaultExpanded: 1,
            masterDetail: true,
            frameworkComponents: {
              btnCellRendererWaste: BtnCellRendererWaste,
            },
            columnDefs: [
              // {
              //   field: 'PPD_ID',
              //   wrapText: true,
              //   resizable: true,
              //   cellRenderer: (params: any) => {
              //     if (params.value && params.value.id) {
              //       return '<div class="area-name">' +
              //         params.value.id +
              //         '' +
              //         '</div>';
              //     } else { return ''; }
              //   },
              //   headerName: 'Level',
              //   rowSpan: this.rowSpan1,
              //   cellClassRules: { 'show-cell': 'value !== undefined' },
              //   cellStyle: (params: any) => {
              //     if (params.value && params.value.id) {
              //       return {
              //         background: '#49FFB9', border: '1px solid #333'
              //       };
              //     } else {
              //       return { background: 'white' };
              //     }
              //   },
              //   width: 150,
              // },
              {
                field: 'Action',
                cellRenderer: 'btnCellRendererWaste',

                cellRendererParams: {
                  clicked: function (field: any) { },
                },
                resizable: true,
                width: 100,
                wrapText: true,
              },
              {
                headerName: 'Serial No',
                field: 'SerialNo',
                filter: 'agTextColumnFilter',
                width: 120,
                sortable: true,
                resizable: true,
                wrapText: true,
                headerValueGetter: this.localizeHeader.bind(this),
              },
              {
                headerName: 'Item',
                field: 'ItemDesc',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,
                headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'Operation Name',
                field: 'PPD_Desc',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,
                headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'Machine',
                field: 'PU_Desc',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,

                headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'Start Date',
                field: 'Start_Time',
                valueFormatter: function (params: any) {
                  if (params.value) {
                    return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
                  }
                  else {
                    return ''
                  }
                },
                sortable: true,
                resizable: true,
                wrapText: true,
                headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'End Time',
                field: 'End_Time',
                valueFormatter: function (params: any) {
                  if (params.value) {
                    return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
                  }
                  else {
                    return ''
                  }
                },
                sortable: true,
                resizable: true,
                wrapText: true,
                headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'Gross Produced',
                field: 'GrossProduced',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,
              },
              {
                headerName: 'Net Produced',
                field: 'NetProduced',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,
                valueFormatter: function (params: any) {
                  if (params.value < 0) {
                    return 0;
                  }
                  else {
                    return params.value
                  }
                },
                headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'Waste',
                field: 'Waste',
                sortable: true,
                resizable: true,
                wrapText: true,

              },
              {
                headerName: 'Waste Reason',
                field: 'WasteReson',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,
                // headerValueGetter: this.localizeHeader.bind(this)
              },
              {
                headerName: 'Category Type',
                field: 'faultName',
                filter: 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                wrapText: true,
                // headerValueGetter: this.localizeHeader.bind(this)
              },
            ],
          },
          getDetailRowData: function (params: any) {
            params.successCallback(params.data.detail);

            // params.successCallback(params.data.detail[0]?.detail.map(ele => {
            //   return {
            //     ...ele,
            //     level: params.data.detail[0].level,
            //     totalcount: params.data.detail[0].totalcount
            //   }
            // }));
          },
        }
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  };

  rowSpan(params: any): any {
    if (params.data.PPD_Desc && params.data.startTime) {
      return params.data.totalcount;
    } else {
      return 1;
    }
  }

  detailCellClicked(params: any): void {
    const col = params.colDef.field;
    const ButtonType = params.event.target.textContent;
    this.AddWasteEnteryForm.reset();
    this.resetWasteEnteryForm();
    if (col === 'Action') {
      if (ButtonType === 'edit') {
        this.dialog.open(this.addWasteModal, { height: '90%', width: '90%' });
        this.getWasteFaultByUnit(params.data.PU_Id);
        this.gridRowObj = params.data;
        this.getWasteEntryHistory();
        this.wasteLabel = params.data.Label;
        const selected = {
          startDate: new Date(params.data.Start_Time),
          endDate: new Date(params.data.End_Time),
        };
        this.AddWasteEnteryForm.get('operation')?.setValue(params.data.PPD_Desc);
        this.AddWasteEnteryForm.get('item')?.setValue(params.data.ItemDesc);
        this.AddWasteEnteryForm.get('datePicker')?.setValue(selected);
        this.AddWasteEnteryForm.get('po')?.setValue(params?.data.ProcessOrder);
        this.AddWasteEnteryForm.get('machine')?.setValue(params?.data.PU_Desc);
      };
    };
  }

  cellClickedWasteGrid(params: any): void {

    const col = params.colDef.field;
    const ButtonType = params.event.target.textContent;
    this.AddWasteEnteryForm.reset();
    this.resetWasteEnteryForm();
    if (col === 'Action') {
      if (ButtonType === 'edit') {
        this.dialog.open(this.addWasteModal, { height: '90%', width: '90%' });
        this.getWasteFaultByUnit(params.data.PU_Id);
        this.gridRowObj = params.data;
        this.getWasteEntryHistory();
        this.wasteLabel = params.data.Label;
        const selected = {
          startDate: new Date(params.data.Start_Time),
          endDate: new Date(params.data.End_Time),
        };
        this.AddWasteEnteryForm.get('operation')?.setValue(params.data.PPD_Desc.name.PPD_Desc);
        this.AddWasteEnteryForm.get('item')?.setValue(params.data?.ItemDesc);
        this.AddWasteEnteryForm.get('datePicker')?.setValue(selected);
        this.AddWasteEnteryForm.get('po')?.setValue(params.data?.ProcessOrder);
        this.AddWasteEnteryForm.get('machine')?.setValue(params?.data.PU_Desc);
      };
    };
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.userService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  };

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  };

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  };

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi1.refreshHeader();
      }
    });
  };

  datasource(): void {
    const key = {
      Id: 0,
    };
    const id = {
      value: 0,
    };
    // tslint:disable-next-line:
    this.userService.getGroupData(key).subscribe(
      (data: any) => {
        this.groupList = data.masterList;
        id.value = data.masterList[0].TypeId;
        this.wasteFilterForm.get('group')?.setValue(data.masterList[0].TypeId);
        if (this.groupList.length > 0) {
          this.filteredGroups = this.groupList.slice();
        }
        this.getPlants(id);
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  };

  getPlants(event: any): void {
    const key = {
      GroupId: event.value,
    };
    const id = {
      value: ''
    }
    // this.orderForm.get('UnitName')?.reset();
    // this.operationForm.get('Machine')?.reset();
    // this.MachineId = '';
    this.machineService.getPlantsData(key).subscribe(
      (data: any) => {
        this.plantList = data.DepartList;
        this.wasteFilterForm.get('plant')?.setValue(this.plantList[0].DeptId);
        id.value = this.plantList[0].DeptId;
        this.getProcessOrder();
        this.getUnits(id);
        this.getWasteData();
        if (this.plantList.length > 0) {
          this.filteredPlant = this.plantList.slice();
        }

      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  };

  getUnits(event: any): void {
    const key = {
      plantId: event.value
    }
    this.wasteService.getUnitByPlant(key).subscribe((res: any) => {
      this.unitList = res.data;
      this.filteredUnit = this.unitList.slice();
    });
  };

  getProcessOrder(): void {
    const key = {
      PlantId: this.wasteFilterForm.value.plant,
      dateStart: new Date(this.wasteFilterForm.value.dateStart),
      dateEnd: new Date(this.wasteFilterForm.value.dateEnd),
    }
    this.poList = [];
    this.wasteService.getProcessOrder(key).subscribe((response: any) => {
      this.poList = response.data;
      this.filteredPo = this.poList.slice();
    })

  };

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout('autoHeight');
    params.api.sizeColumnsToFit();
    const e: HTMLElement = document.querySelector('#eGrid') as HTMLElement;
    if (e !== null) {
      e.style.height = '';
    }
  };

  onGridReady1(params: any): any {
    this.gridApi1 = params.api;
    this.gridColumnApi1 = params.columnApi;
    this.gridApi1.setDomLayout('autoHeight');
    params.api.sizeColumnsToFit();
    const e: HTMLElement = document.querySelector('#eGrid1') as HTMLElement;
    if (e !== null) {
      e.style.height = '';
    }
  };

  onGridReadyWastHistory(params: any): any {
    this.gridApiWast = params.api;
    this.gridColumnApiWast = params.columnApi;
    this.gridApiWast.setDomLayout('autoHeight');
    const e: HTMLElement = document.querySelector('#ewastGrid') as HTMLElement;
    if (e !== null) {
      e.style.height = '';
    }
  };



  getWasteData(): void {
    const key =
    {
      PlantId: this.wasteFilterForm.value.plant,
      UnitId: this.wasteFilterForm.value.unit ? this.wasteFilterForm.value.unit : 0,
      dateStart: new Date(this.wasteFilterForm.value.dateStart),
      dateEnd: new Date(new Date(this.wasteFilterForm.value.dateEnd).setHours(23, 59, 59, 999)),
      POId: this.wasteFilterForm.value.processOrder ? this.wasteFilterForm.value.processOrder : 0,
    };
    // this.rowData = [key];
    this.gridApi1.showLoadingOverlay();
    // let data1 = [];
    this.wasteService.getWaste(key).subscribe((res: any) => {
      this.rowData = res.data;
      this.rowData.forEach((item: any) => {
        let grossProduce = 0;
        item.Start_Time = item.Start_Time !== null ? moment(item.Start_Time).format('DD/MM/YYYY HH:mm A') : '';
        item.End_Time = item.End_Time !== null ? moment(item.End_Time).format('DD/MM/YYYY HH:mm A') : '';
        if (item?.detail && item?.detail?.length > 0) {
          let machineNames = item.detail.map((d: any) => { return d.PU_Desc; });
          machineNames = [...new Set(machineNames)];
          for (let m = 0; m < machineNames.length; m++) {
            const data = item.detail.find(x => x.PU_Desc == machineNames[m]);
            grossProduce += data?.GrossProduced ? data?.GrossProduced : 0;
          }
          item['GrossProduced'] = isNaN(grossProduce) ? 0 : grossProduce;
          item['NetProduced'] = (isNaN(grossProduce) ? 0 : grossProduce) - item?.Waste;
        }
      });
      // res.data.forEach(element => {
      //   element.detail.forEach((d, index) => {
      //     console.log(index);

      //     if (index === 0) return;
      //     else {
      //       d.PU_Desc = ''
      //     }
      //   });
      // });


      // formate data according to the ag grid
      // let uniqueIds: any[] = [];
      // res?.data.forEach((element: any, index: any) => {
      //   uniqueIds = [... new Set(element.detail?.map((item: any) => {
      //     return item.PPD_ID;
      //   }))];

      //   element.newDetail = [];

      //   uniqueIds.forEach(id => {
      //     const filteredArray = element.detail.filter((x: any) => x?.PPD_ID === id);
      //     if (filteredArray.length > 0) {
      //       filteredArray.forEach((d: any) => {
      //         const foundPPdId = element.newDetail.findIndex((item: any) => {
      //           return item?.PPD_ID?.id === id;
      //         });

      //         if (foundPPdId === -1) {
      //           element.newDetail.push({
      //             PPD_ID: {
      //               id: id
      //             },
      //             ItemDesc: {
      //               itemDesc: d.ItemDesc
      //             },

      //             PPD_Desc: {
      //               ppdDesc: d.PPD_Desc
      //             },

      //             PU_Desc: {
      //               puDesc: d.PU_Desc
      //             },

      //             Start_Time: {
      //               startTime: d.Start_Time
      //             },

      //             End_Time: {
      //               endTime: d.End_Time
      //             },
      //             totalcount: filteredArray?.length,
      //             Label: d.Label,
      //             Waste: d.Waste,
      //             Status: d.Status,
      //             SerialNo: d.SerialNo,
      //             de: d.de
      //           });
      //         } else {
      //           element.newDetail.push({
      //             // PPD_ID: {
      //             //   id: id
      //             // },
      //             // ItemDesc: {
      //             //   itemDesc: d.ItemDesc
      //             // },

      //             // PPD_Desc: {
      //             //   ppdDesc: d.PPD_Desc
      //             // },

      //             // PU_Desc: {
      //             //   puDesc: d.PU_Desc
      //             // },

      //             // Start_Time: {
      //             //   startTime: d.Start_Time
      //             // },

      //             // End_Time: {
      //             //   endTime: d.End_Time
      //             // },
      //             Label: d.Label,
      //             Waste: d.Waste,
      //             Status: d.Status,
      //             SerialNo: d.SerialNo,
      //             de: d.de
      //           });
      //         }
      //       });
      //     }
      //   });

      // });
      // console.log(res.data, 'Formatted detaill arr')
      // let levelArray = [... new Set(this.formattedDetailArray?.map((item: any) => item.level))];
      // let formateddata: any[] = [];
      // let formatedLevelArray = [];
      // this.formattedDetailArray.forEach(element => {
      //   levelArray?.forEach((elem: any) => {
      //     const key = {
      //       ItemDesc: element.ItemDesc,
      //       PPD_Desc: element.PPD_Desc,
      //       PU_Desc: element.PU_Desc,
      //       Start_Time: element.Start_Time,
      //       End_Time: element.End_Time,
      //       level: elem,
      //       totalcount: this.filteredArray?.length,
      //       detail: []
      //     }
      //     formatedLevelArray?.push(key)
      //   })
      // });

      // formatedLevelArray?.forEach((elem: any) => {
      //   this.formattedDetailArray?.forEach((elem2: any) => {

      //     if (elem.level === elem2?.level) {
      //       elem.detail.push(elem2.detail)
      //     }
      //   });
      // });

      // console.log('formated', formatedLevelArray);
      // this.rowData.forEach((element: any, index: any) => {
      //   element.detail = [];
      //   element.detail.push(formatedLevelArray[index])
      // });
      // console.log(this.rowData, 'Row Data')
    });

  };


  cellClicked(params: any): void {
    const col = params.colDef.field;
    const ButtonType = params.event.target.textContent;
    this.AddWasteEnteryForm.reset();
    this.resetWasteEnteryForm();
    this.openWastHistoryModal(params);
    if (col === 'Action') {
      if (ButtonType === 'edit') {
        this.dialog.open(this.addWasteModal, { height: '90%', width: '90%' });
        this.getWasteFaultByUnit(params.data.PU_Id);
        this.gridRowObj = params.data;
        this.getWasteEntryHistory();
        this.wasteLabel = params.data.Label;
        const selected = {
          startDate: new Date(params.data.Start_Time),
          endDate: new Date(params.data.End_Time),
        };
        this.AddWasteEnteryForm.get('operation')?.setValue(params.data.PPD_Desc);
        this.AddWasteEnteryForm.get('item')?.setValue(params.data.ItemDesc);
        this.AddWasteEnteryForm.get('datePicker')?.setValue(selected);
        this.AddWasteEnteryForm.get('po')?.setValue(params?.data.ProcessOrder);
        this.AddWasteEnteryForm.get('machine')?.setValue(params?.data.PU_Desc);
      };
    };
  };

  getWasteFaultByUnit(param): void {
    const key = {
      PUId: param,
      UserId: 0,
    };
    this.wasteService.getWasteFaultByUnit(key).subscribe((res: any) => {
      this.faultList = res.FaultList;
      console.log('faultlist', this.faultList)
      this.AddWasteEnteryForm.get('categoryType')?.setValue(this.faultList[0]?.FaultId);


    });
  }

  addWasteEntry(): void {
    console.log(this.gridRowObj.End_Time)
    const key = {
      FaultID: this.AddWasteEnteryForm.value.categoryType,
      amount: this.AddWasteEnteryForm.value.amount,
      remarks: this.AddWasteEnteryForm.value.remarks,
      dateStart: this.gridRowObj.End_Time,
      PPDID: this.gridRowObj.PPD_ID,
      PU_Id: this.gridRowObj.PU_Id
    }
    let lastDate = new Date(key.dateStart);
    let nowDate = new Date();
    let differInTime = nowDate.getTime() - lastDate.getTime();
    let differInDays = differInTime / (1000 * 3600 * 24);
    if (differInDays >= 2) {
      this.toaster.warning('warn', 'Date Exceeded')
    }
    else {
      this.wasteService.addWasteEntery(key).subscribe((response: any) => {
        console.log('add repones', response);
        if (response.data[0].message === 'OK') {
          this.toaster.success('Success', 'Successfully Saved');
          this.wastDialogRef.close();
          this.getWasteEntryHistory();
          this.resetWasteEnteryForm();
          this.getWasteData();
        }
        else {
          this.toaster.warning('Warning', 'Date Exceeded')
        }
      });
    }
  }

  onChangeDate(event: any): void {
    if (this.wasteFilterForm.value.dateEnd && this.wasteFilterForm.value.dateStart)
      this.getProcessOrder();
  }

  getWasteEntryHistory(): void {
    const key = {
      PPDID: this.gridRowObj.PPD_ID,
      dateStart: this.gridRowObj.Start_Time,
      dateEnd: this.gridRowObj.End_Time,
    }
    this.wasteService.getWasteEntryHistory(key).subscribe((historyList: any) => {
      this.rowDataHistory = historyList.data;
    });
  }

  cellClickedHistory(param: any): void {
    const col = param.colDef.field;
    this.historyGridRowObj = null;
    const ButtonType = param.event.target.textContent;
    if (col === 'Action') {
      if (ButtonType === 'edit') {
        this.editMode = true;
        this.historyGridRowObj = param.data;
        this.AddWasteEnteryForm.get('categoryType').setValue(param.data.FaultId);
        this.AddWasteEnteryForm.get('remarks').setValue(param.data.Remarks);
        this.AddWasteEnteryForm.get('amount').setValue(param.data.Amount);
      }

    }
  }

  editWasteEntry(): void {
    console.log('data', this.historyGridRowObj)
    const key = {
      wasteEntryId: this.historyGridRowObj.WasteEntryId,
      Amount: this.AddWasteEnteryForm.value.amount,
      Remarks: this.AddWasteEnteryForm.value.remarks,
      FaultId: this.AddWasteEnteryForm.value.categoryType,
    }
    this.wasteService.updateWasteEntry(key).subscribe((res: any) => {
      console.log(res, 'res');
      if (res?.data[0].message === 'Updated') {
        this.toaster.success('Success', 'Successfully Updated');
        this.getWasteEntryHistory();
        this.resetWasteEnteryForm();
        this.getWasteData();
      }
      else {
        this.toaster.warning('warning', 'Not Updated');
      }
    });
  }

  resetWasteEnteryForm(): void {
    // this.AddWasteEnteryForm.reset();
    this.editMode = false;
    this.AddWasteEnteryForm.get('categoryType')?.setValue('');
    this.AddWasteEnteryForm.get('remarks').setValue('');
    this.AddWasteEnteryForm.get('amount').setValue('');

  }


  rowSpan1(params: any): any {
    if (params.data.PPD_ID.id) {
      return params.data.totalcount;
    } else {
      return 1;
    }
  }


  // rowSpan(params: RowSpanParams) {
  //   if (params.data.PU_Desc === 'Masterfold') {
  //     console.log('866');
  //     return 6;
  //   } else {
  //     return 1;
  //   }
  // }

  // onBtnExportParentData(): void {
  //   const params = {
  //     fileName: 'Waste Report Haders Data',
  //   }
  //   this.gridOptions.api.exportDataAsExcel(params);
  // }

  onBtExport() {
    this.gridApinew.exportDataAsExcel();
  }
  onGridReadynew(params: any) {
    this.gridApinew = params.api;
  }
}

